import React from "react";
import { Grid, GridProps } from "@mui/material";

import { SUBHEAD_HEIGHT } from "@config";

type PageLayoutProps = {
  children: React.ReactNode;
  spacing?: GridProps["spacing"];
  p?: GridProps["p"];
  pb?: GridProps["pb"];
  maxHeight?: string;
  overflow?: string;
} & Omit<
  GridProps,
  "container" | "children" | "spacing" | "p" | "pb" | "overflow" | "flexGrow" | "maxHeight" | "mt"
>;

export const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  spacing = 2,
  p = 4,
  pb,
  maxHeight = `calc(100vh - 5.14rem - ${SUBHEAD_HEIGHT}px)`,
  overflow = "none",
  ...gridProps
}) => {
  return (
    <Grid
      container
      p={p}
      gap={spacing}
      pb={pb}
      overflow={overflow}
      flexGrow={1}
      maxHeight={maxHeight}
      mt={0}
      {...gridProps}
    >
      {children}
    </Grid>
  );
};
